import { BaseModel } from './index';

export enum StyleLanguage {
  CSS = 1,
  SCSS = 2,
  LESS = 3,
}

export enum StyleMediaType {
  All = 'all',
  Mobile = 'mobile',
  Tablet = 'tablet',
  Desktop = 'desktop',
  MobileOrTablet = 'mobile_or_tablet',
  DesktopOrTablet = 'tablet_or_desktop',
}

export enum StyleLabelType {
  SubscriptionStatus = '1',
}

export interface Style extends BaseModel {
  name: string;
  language: StyleLanguage;
  content: string;
  is_system: boolean;
  campaign: string | number | null;
  variables: { [key: string]: string };
  omp_theme?: { [key: string]: string } | null;
  styles: any;
  labels: any;
  header_enhanced_mode?: boolean;
  footer_enhanced_mode?: boolean;
  header_enhanced_content?: string;
  footer_enhanced_content?: string;
  header_style?: string;
  footer_style?: string;
}

export interface StyleVariable {
  name: string;
  value: string;
}

export interface ColorSwatch {
  label: string;
  color: string;
}

export const BrandColorLabels: { [key: string]: string } = {
  theme_color: 'Main Theme Color',
  button_hover_color: 'Button Hover Color',
  button_active_color: 'Button Active Color',
  button_shadow_color: 'Button Shadow Color',
  selection_background_color: 'Selection Background Color',
  action_color: 'Action Button Color',
};

export enum ColorInputFormat {
  Hex = 'hex',
  Rgb = 'rgb',
}

export const EssentialColorSwatches: ColorSwatch[] = [
  { label: 'Black', color: '#000000' },
  { label: 'White', color: '#ffffff' },
];

export const ColorToneStops = [-0.6, -0.4, -0.2, 0, 0.2, 0.4, 0.6];
export const CustomColorSwatchesLimit = 16;
export const ColorSwatchesStoragePrefix = 'color_swatches_';
export const ColorSwatchPopoverWidth = 315;
export const ColorSwatchPopoverGap = 6;
export const ColorSwatchAppliedDelayMs = 300;

// TinyMCE formatter names behind the swatch-colors plugin's text / highlight buttons.
export enum EditorColorFormat {
  Text = 'forecolor',
  Highlight = 'hilitecolor',
}

// What a TinyMCE color button edits: its starting color, live apply, and optional remove / extra revert on cancel.
export interface EditorColorTarget {
  color: string;
  apply: (color: string) => void;
  remove?: () => void;
  revert?: () => void;
}

export interface ColorSwatches {
  brand: ColorSwatch[];
  custom: string[];
}

export const defaultThemeColor = '#8bc31f';
export const whiteColor = '#ffffff';
export const greyFontColor = '#707070';
export const transparent = '#00000000'
